<template>
  <ul v-if="state" class="search-hits">
    <li
      v-for="(product, index) in products"
      :key="product._id"
      class="search-hits__product"
      :style="`order: ${index + 1}`"
    >
      <p-product-thumbnail
        :product-id="product._id"
        :product-slug="product.slug"
        :is-authenticated="isAuthenticated"
        :index="index"
      />
    </li>
    <slot></slot>
  </ul>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { AisHits, createWidgetMixin } from 'vue-instantsearch/vue3/es'
import type { ProductHit } from '@b2ag/search'
import { connectInfiniteHits } from 'instantsearch.js/es/connectors'
import PProductThumbnail from '@b2ag/product/src/presenters/PProductThumbnail/PProductThumbnail.vue'

export default defineComponent({
  name: 'PSearchHits',
  extends: AisHits,
  props: {
    isAuthenticated: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [createWidgetMixin({ connector: connectInfiniteHits })],
  components: { PProductThumbnail },
  computed: {
    currentAddress() {
      return this.$store.getters['addresses/currentAddress']
    },
    algoliaHits() {
      // @ts-ignore: MERCI DE DIRE POURQUOI CE TS IGNORE EST LÀ
      return this.state?.hits || []
    },
    products() {
      // @ts-ignore: MERCI DE DIRE POURQUOI CE TS IGNORE EST LÀ
      return this.algoliaHits.map((hit) => ({ _id: hit._id, slug: hit.slug }))
    },
  },
  watch: {
    algoliaHits(hits: ProductHit[]) {
      this.$emit('hit', hits)
    },
    currentAddress() {
      this.$store.commit('shop/RESET_SHOP')
      this.$emit('hit', this.algoliaHits)
    },
  },
})
</script>

<style lang="scss">
.search-hits {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: var(--spacing-3) var(--spacing-4);
  padding: 0;
  list-style: none;
  margin: auto;
  align-items: center;

  @media (min-width: $breakpoint-sm) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: $breakpoint-md) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: $breakpoint-xl) {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
